// extracted by mini-css-extract-plugin
export default {"title":"title___bVeEs","url":"url___KWJUQ","navs":"navs___l8VQg","activated":"activated___kBgk2"};